// src/pages/PersonalizacaoLoja.jsx
import React, { useContext, useEffect, useState } from 'react';
import styles from './PersonalizacaoLoja.module.css';
import FooterOpcoes from '../../cliente/components/FooterOpcoes';
import { EstabelecimentosContext } from '../../../shared/contexts/EstabelecimentosContext';

function PersonalizacaoLoja() {
  const { estabelecimentos } = useContext(EstabelecimentosContext);
  const [estabelecimento, setEstabelecimento] = useState(null);

  useEffect(() => {
    const idEstabelecimento = Number(localStorage.getItem('estabelecimento_id'));
    const estAtual = estabelecimentos.find(est => est.id_estabelecimento === idEstabelecimento);
    setEstabelecimento(estAtual || null);
  }, [estabelecimentos]);

  if (!estabelecimento) return <p>Carregando informações da loja...</p>;

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <h1>Personalização da Loja</h1>
      </header>

      <section className={styles.aparencia}>
        <img 
          src={estabelecimento.logo || '/default-logo.png'} 
          alt="Logo da Loja" 
          className={styles.logo} 
        />
        <div className={styles.info}>
          <h2>{estabelecimento.nome_loja}</h2>
          <p>{estabelecimento.endereco}</p>
        </div>
      </section>

      <section className={styles.configuracoes}>
        <div className={styles.configItem}>
          <h3>Telefone</h3>
          <p>{estabelecimento.telefone}</p>
        </div>
        <div className={styles.configItem}>
          <h3>Site</h3>
          <p>{estabelecimento.site}</p>
        </div>
      </section>

      <FooterOpcoes typeView="admin" />
    </div>
  );
}

export default PersonalizacaoLoja;
